import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import * as jwtDecode from 'jwt-decode'; // Import a library for decoding JWT tokens
import AppRoutes from './AppRoutes';
import TauriLayout from './components/TauriLayout/TauriLayout';
import PageNotFound from './PageNotFound/PageNotFound';
import { BaseManagerProvider } from './BaseManager/BaseManager';

const App = () => {
  const { pathname } = useLocation();

  const navigate = useNavigate();
  const location = useLocation();

  // Store the last visited route in localStorage
  useEffect(() => {
    localStorage.setItem('lastNavigated', pathname);
  }, [pathname]);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [location, navigate]);

  // Retrieve the last visited route from localStorage
  const lastNavigated = localStorage.getItem('lastNavigated');

  useEffect(() => {
    if (
      window.matchMedia('(min-width: 768px)').matches &&
      window.screen.orientation?.lock
    ) {
      window.screen.orientation
        .lock('landscape')
        .catch((err) =>
          console.warn('Orientation lock not supported:', err)
        );
    }
  }, []);

  return (
    <BaseManagerProvider>
      <TauriLayout>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      </TauriLayout>
    </BaseManagerProvider>
  );
};

export default App;